import React from 'react';
import { Card, CardContent } from './ui/Card';
interface StatCardProps {
  value: string;
  label: string;
  description?: string;
  icon?: React.ReactNode;
}
export function StatCard({
  value,
  label,
  description,
  icon
}: StatCardProps) {
  return <Card className="bg-white border-none shadow-lg hover:-translate-y-2 transition-all duration-300 text-center relative overflow-hidden group" data-id="element-688" data-mp="oimm65w1diec">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-primary to-brand-orange opacity-80" data-id="element-689" data-mp="emszvusimajd" />
      <CardContent className="pt-8 pb-6 px-6 flex flex-col items-center" data-id="element-690" data-mp="akg3hwznroz9">
        {icon && <div className="mb-4 text-brand-orange animate-soft-float" data-id="element-691" data-mp="5ktiv2hi36gf">
            {icon}
          </div>}
        <div className="text-5xl md:text-6xl font-extrabold text-primary mb-3 font-heading tracking-tight group-hover:scale-105 transition-transform duration-300" data-id="element-692" data-mp="ntmxked7k31">
          {value}
        </div>
        <div className="font-bold text-primary-dark text-lg md:text-xl mb-2" data-id="element-693" data-mp="1v1ku8d981rvb">
          {label}
        </div>
        {description && <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-694" data-mp="oxpl09g0zo3o">
            {description}
          </p>}
      </CardContent>
    </Card>;
}